import { useState } from "react"

import AlertCheckout from "./alert_checkout"
import ErrorIcon from "images/icons/icon-error.svg"

import "./banner.scss"

interface Props {
  checkoutModalTarget: string
  twitterMigration: boolean
  urls: { learnMore: string }
}

const Banner = (props: Props) => {
  const [showCheckout, setShowCheckout] = useState(false)
  const onFinish = () => setShowCheckout(false)
  const handleUpgradeClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    setShowCheckout(true)
  }

  return (
    <>
      <div styleName="free-tier-migration-banner">
        <span dangerouslySetInnerHTML={{ __html: ErrorIcon }} styleName="mobile-icon" />

        <span styleName="copies" className="txt-body-3">
          <span styleName="introduction">
            <span dangerouslySetInnerHTML={{ __html: ErrorIcon }} styleName="desktop-icon" />
            Updates to your free account.&nbsp;
          </span>
          <a href="" onClick={handleUpgradeClick}>
            Learn more.
          </a>
        </span>
      </div>
      {showCheckout && <AlertCheckout {...props} onFinish={onFinish} />}
    </>
  )
}

export default Banner
